import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function LightModeIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m2.40381 2.40381 0.38302 0.38302" strokeWidth="1"></path>
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m11.2133 11.2134 0.383 0.383" strokeWidth="1"></path>
    <path id="Vector_3" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m7.00012 0.5 0 0.54167" strokeWidth="1"></path>
    <path id="Vector_4" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m7.00012 12.9584 0 0.5416" strokeWidth="1"></path>
    <path id="Vector_5" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m13.5001 7 -0.5416 0" strokeWidth="1"></path>
    <path id="Vector_6" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M1.04175 7 0.50008 7" strokeWidth="1"></path>
    <path id="Vector_7" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m11.5963 2.40381 -0.383 0.38302" strokeWidth="1"></path>
    <path id="Vector_8" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m2.78687 11.2134 -0.38302 0.383" strokeWidth="1"></path>
    <path id="Vector 82" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M7 9.33972C5.05023 9.33972 4.66028 8.16986 4.66028 7S5.05023 4.66028 7 4.66028c1.94977 0 2.33972 1.16986 2.33972 2.33972S8.94977 9.33972 7 9.33972Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
